import { HttpClient } from "../HttpClient";
import { useImpersonateStore } from "@/store/impersonateStore";

/**
 * * Get Deductions
 */
export const Logout = async () => {
  localStorage.removeItem("announcementNotice_vvv");
  localStorage.removeItem("announcementNotice_cs");

  try {
    // Clear impersonation state before logout
    const impersonateStore = useImpersonateStore();
    impersonateStore.resetImpersonation();

    const { data } = await HttpClient.delete("api/users/logout");
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};